import * as React from 'react';
import { Location, LocationParams } from 'lib/componentLocation';
import { IRoute } from 'lib/componentRouter';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';
import { TopicCardTemplates, TopicCardTemplatesParams } from './model';
import { TopicCardTemplatesView } from './view';

export function TopicCardTemplatesRoute(
    model : (params : TopicCardTemplatesParams) => TopicCardTemplates,
    appWrapper : AppWrapper,
    request : Location
) : IRoute {
    const m = model(inboundParams(request));
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <TopicCardTemplatesView model={m} />
            </AppWrapperView>,
        reflectState: () => outboundParams(request, m)
    };
}

function inboundParams(request : Location) : TopicCardTemplatesParams {
    return {
        id: +(request.params['id'] || 0),
        templateId: +(request.params['templateId'] || 0) // coerce undefined to 0, which is what we want - indicates no template selected
    };
}

function outboundParams(request : Location, m : TopicCardTemplates) {
    const params = {} as LocationParams;
    params['id'] = '' + m.Id;
    if (m.SelectedTemplateId()) params['templateId'] = '' + m.SelectedTemplateId();
    return new Location(request.name, params);
}


// WEBPACK FOOTER //
// ./apps/portcall/topiccardtemplates/route.tsx